import React from 'react'
import PropTypes from 'prop-types'

// The schedule page (`pages/schedule/index.js`) wraps every step in a box with
// this min-height so short steps still push the footer to the bottom of the
// viewport. That box is not a fixed height, so a step's `min-height: 100%`
// resolves to nothing and a colored step background stops at its content,
// leaving a white band above the footer. Wrap a redesigned step in this
// component to paint its background over the whole box instead.
export const SCHEDULE_PAGE_MIN_HEIGHT = 'calc(100vh - 120px)'

const SchedulePageBackground = ({ color, className, children }) => (
  <div
    className={className}
    style={{ backgroundColor: color, minHeight: SCHEDULE_PAGE_MIN_HEIGHT }}
  >
    {children}
  </div>
)

SchedulePageBackground.propTypes = {
  color: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
}

export default SchedulePageBackground
